import React from 'react';

export const CommentSkeleton: React.FC = () => (
  <div className="gc-skeleton w-full">
    <div className="gc-skeleton-comment">
      <div className="gc-skeleton-avatar" />
      <div className="gc-skeleton-line first" />
      <div className="gc-skeleton-line" />
      <div className="gc-skeleton-line" />
      <div className="gc-skeleton-line last" />
      <div className="gc-skeleton-actions">
        <div className="gc-skeleton-action" />
        <div className="gc-skeleton-action" />
        <div className="gc-skeleton-action" />
      </div>
    </div>
    <div className="gc-skeleton-bubble-flow">
      <div className="gc-skeleton-bubble" />
      <div className="gc-skeleton-bubble" />
      <div className="gc-skeleton-bubble" />
      <div className="gc-skeleton-bubble" />
      <div className="gc-skeleton-bubble" />
      <div className="gc-skeleton-bubble" />
      <div className="gc-skeleton-bubble" />
      <div className="gc-skeleton-bubble" />
      <div className="gc-skeleton-bubble" />
    </div>
    <div className="gc-skeleton-child-comment">
      <div className="gc-skeleton-avatar" />
      <div className="gc-skeleton-line first" />
      <div className="gc-skeleton-line" />
      <div className="gc-skeleton-actions">
        <div className="gc-skeleton-action" />
        <div className="gc-skeleton-action" />
        <div className="gc-skeleton-action" />
      </div>
    </div>
    <div className="gc-skeleton-bubble-flow last">
      <div className="gc-skeleton-bubble" />
      <div className="gc-skeleton-bubble" />
    </div>
    <div className="gc-skeleton-footer" />
  </div>
);

export default CommentSkeleton;
